export default __webpack_public_path__ + "static/retreat_8-e5e40b783f034757417941ebfd9bf780.jpg";